import { ENV } from "cortex/ui/src/constant/app";
import { Role, User } from "cortex/ui/src/user/model";

type VisibilityMap = Record<string, boolean>;

const { FLEET_URL } = ENV;

const OPERATOR: VisibilityMap = {
  "/overview": true,
  "/devices": true,
  "/devices/config/generate": true,
  "/devices/config/import": true,
  "/devices/bulk-edit": true,
  "/v2/strategies": true,
  "/v2/strategies/create": false,
  "/v2/strategies/deploy": true,
  "/v2/strategies/deployments": true,
  "/v2/strategies/media-library": true,
  "/v2/strategies/scheduled": false,
  "/applications": true,
  "/applications/upload": false,
  "/applications/store": true,
  "/networks": true,
  "/networks/create": false,
  "/events": true,
  "/events/deploy": true,
  "/events/account": true,
  "/diagnostics": true,
  "/diagnostics/alerts": true,
  "/diagnostics/alerts/create": true,
  "/diagnostics/incidents": true,
  "/diagnostics/uptime-report": true,
  "/alerts": true,
  "/alerts/create": false,
  "/users": false,
  "/users/create": false,
  "/download": true,
  [`${FLEET_URL}/download/`]: true,
};

const READONLY: VisibilityMap = {
  "/overview": true,
  "/devices": true,
  "/devices/bulk-edit": false,
  "/devices/config/generate": true,
  "/devices/config/import": false,
  "/diagnostics": true,
  "/diagnostics/alerts": true,
  "/diagnostics/alerts/create": false,
  "/diagnostics/incidents": true,
  "/diagnostics/uptime-report": true,
  "/v2/strategies": true,
  "/v2/strategies/create": false,
  "/v2/strategies/deploy": false,
  "/v2/strategies/deployments": true,
  "/v2/strategies/media-library": true,
  "/v2/strategies/scheduled": false,
  "/applications": true,
  "/applications/upload": false,
  "/applications/store": true,
  "/networks": true,
  "/networks/create": false,
  "/events": true,
  "/events/deploy": true,
  "/events/account": true,
  "/events/v3": true,
  "/alerts": true,
  "/alerts/create": false,
  "/users": false,
  "/users/create": false,
  "/download": true,
  [`${FLEET_URL}/download/`]: true,
};

const ADMIN_OPERATOR: VisibilityMap = {
  "/users": false,
  "/users/create": false,
};

// This class is a util to evaluate if a user has visibility into
// certain nav items, not a real 'Permissions' checking.
export function isHidden(user: User, path: string): boolean {
  if (!user || user.disabled) {
    return true;
  }

  const role = user.role as Role;

  if (role === "W") {
    return false;
  }

  if (role === "A") {
    if (path in ADMIN_OPERATOR) {
      return !ADMIN_OPERATOR[path];
    }
    return false;
  }

  if (role === "O") {
    if (path in OPERATOR) {
      return !OPERATOR[path];
    }

    return true;
  }

  if (role === "R") {
    if (path in READONLY) {
      return !READONLY[path];
    }
  }

  return true;
}
